import { da } from 'date-fns/locale';
import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Inject,
  Output,
  ViewChild,
} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Subject } from 'rxjs';
import { Parametros } from 'src/app/services/domain/services-domain';
import { UtilService } from 'src/app/services/util.service';
import {
  newmetadate,
  style,
} from 'src/app/shared/components/datatable/domain/datatable-domain';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { MantenimientoRespository } from 'src/app/mantenimiento/servicio/mantenimiento.repository';
import { StorageService } from 'src/app/services/storage.service';
import {
  TablaNaveViajeTNS,
  TNSNaveViajeRequest,
} from '../../domain/nave-viaje.request';
import { MessageService } from 'primeng/api';
@Component({
  selector: 'app-mantenimiento-nave-viaje',
  templateUrl: './mantenimiento-nave-viaje.component.html',
  styleUrls: ['./mantenimiento-nave-viaje.component.css'],
  standalone: false,
})
export class MantenimientoNaveViajeComponent {
  protected _onDestroy = new Subject<void>();
  @Output() outputLogin = new EventEmitter<any>();
  @Output() dataUpdated = new EventEmitter<any>();
  group_edicion: FormGroup;
  parametros: Parametros[] = [];
  usuario: '';
  loading: boolean = false;
  row: any;
  ListaTodasNaves: any[] = [];
  ListaTodosNave: any[] = [];
  ListaTodosTransportista: any[] = [];
  ListaAgentePortuario: any[] = [];
  ListaTerminalPortuario: any[] = [];
  ListaTodosRegimen: any[] = [];
  ListaTodosVia: any[] = [];
  ListaTodosPuerto: any[] = [];
  ListaPuertosFiltrados: any[] = [];
  ListaTodosEstado: any[] = [];
  esEditar: boolean = true;
  tipo: string;
  nomUsuario: string;
  origen: string = ''; // Para guardar el origen del componente
  dataordenventa: any;
  usrcreacion: string = '';
  feccreacion: string = '';
  usremitestatemnt: string = '';
  fecemitestatemnt: string = '';
  usrprefactura: string = '';
  fecprefactura: string = '';
  usrcerrarnave: string = '';
  feccerrarnave: string = '';

  btn_guardar: boolean = false;
  btn_archivos: boolean = false;
  btn_emails: boolean = false;
  btn_email_almacen: boolean = false;
  btn_email_cancelacion_recalada: boolean = false;
  btn_email_demora_arribo: boolean = false;
  btn_email_emitir_bl: boolean = false;
  btn_email_aviso_llegada: boolean = false;
  btn_email_carga_tarjada_lcl: boolean = false;
  btn_email_carga_tarjada_fcl: boolean = false;
  btn_archivo_direccionamiento: boolean = false;
  btn_archivo_vobo: boolean = false;

  readonlyVia: boolean = true;
  // readonlyRegimen: boolean = false;
  readonlyPuerto: boolean = false;
  readonlyNroViaje: boolean = false;
  readonlyTransportista: boolean = false;
  readonlyEta: boolean = false;
  readonlyLlegada: boolean = false;
  readonlyDescarga: boolean = false;
  readonlyCierre: boolean = false;
  readonlyManifiesto: boolean = false;
  readonlyDesconsolidado: boolean = false;
  readonlyZarpe: boolean = false;
  readonlyTerminalPortuario: boolean = false;
  readonlyAgente: boolean = false;
  readonlyAgente2: boolean = false;
  constructor(
    private util: UtilService,
    private readonly mantenimientorepository: MantenimientoRespository,
    private readonly storage: StorageService,
    public reference: DynamicDialogRef,
    @Inject(DynamicDialogConfig) private data: DynamicDialogConfig,
    private cdRef: ChangeDetectorRef,
    private messageService: MessageService
  ) {
    this.row = data.data.row;
    this.tipo = data.data.tipo;
    this.ListaTodasNaves = data.data.ListaTodasNaves;
    this.ListaTodosNave = data.data.ListaTodasNaves;
    this.ListaTodosTransportista = data.data.ListaTodosTransportista;
    this.ListaAgentePortuario = data.data.ListaAgentePortuario;
    this.ListaTerminalPortuario = data.data.ListaTerminalPortuario;
    this.ListaTodosRegimen = data.data.ListaTodosRegimen;
    this.ListaTodosVia = data.data.ListaTodosVia;
    this.ListaTodosPuerto = data.data.ListaTodosPuerto;
    this.ListaTodosEstado = data.data.ListaTodosEstado;
    this.nomUsuario = data.data.nomUsuario;
    this.origen = data.data.origen;
    this.dataordenventa = data.data.datosordenventa;
  }

  datatableDetNaveViaje: any[] = [];
  metadataDetNaveViaje: newmetadate[] = [
    { field: 'nvia_feceta', title: 'Fecha ETA', inputType: 'date' },
    { field: 'dvia_fecetd', title: 'Fecha ETD', inputType: 'date' },
    { field: 'tipo_descpai', title: 'País', inputType: 'text' },
    { field: 'puer_nombre', title: 'Puerto', inputType: 'text' },
  ];

  datatableAuditoriaNaveViaje: any[] = [];
  metadataAuditoriaNaveViaje: newmetadate[] = [
    { field: 'operacion', title: 'Operación', inputType: 'text' },
    { field: 'direccion_ip', title: 'Dirección IP', inputType: 'text' },
    { field: 'nombre_maquina', title: 'Nombre Máquina', inputType: 'text' },
    {
      field: 'nombre_aplicacion',
      title: 'Nombre Aplicación',
      inputType: 'text',
    },
    { field: 'usuario_sql', title: 'Usuario SQL', inputType: 'text' },
    {
      field: 'usuario_aplicacion',
      title: 'Usuario Aplicación',
      inputType: 'text',
    },
    {
      field: 'fecha_modificacion',
      title: 'Fecha Modificación',
      inputType: 'date',
    },
    { field: 'codigo_viaje', title: 'Código Viaje', inputType: 'text' },
    { field: 'estado_viaje', title: 'Estado Viaje', inputType: 'text' },
    { field: 'numero_viaje', title: 'Número Viaje', inputType: 'text' },
    { field: 'codigo_nave', title: 'Código nave', inputType: 'text' },
    { field: 'fecha_cut_off', title: 'Fecha Cut Off', inputType: 'date' },
    { field: 'codigo_puerto', title: 'Código Puerto', inputType: 'text' },
    { field: 'trafico', title: 'Tráfico', inputType: 'text' },
    { field: 'codigo_trafico', title: 'Código Tráfico', inputType: 'text' },
    { field: 'regimen', title: 'Régimen', inputType: 'text' },
    { field: 'codigo_regimen', title: 'Código Régimen', inputType: 'text' },
    { field: 'via', title: 'Vía', inputType: 'text' },
    { field: 'codigo_via', title: 'Código Vía', inputType: 'text' },
    {
      field: 'codigo_transportista',
      title: 'Código Transportista',
      inputType: 'text',
    },
    {
      field: 'codigo_agente_portuario',
      title: 'Código Agente Portuario',
      inputType: 'text',
    },
    {
      field: 'codigo_agente_vobo2',
      title: 'Código Agente VoBo2',
      inputType: 'text',
    },
    { field: 'fecha_eta_etd', title: 'Fecha ETA ETD', inputType: 'date' },
    { field: 'fecha_descarga', title: 'Fecha Descarga', inputType: 'date' },
    {
      field: 'fecha_llegada_zarpe',
      title: 'Fecha Llegada Zarpe',
      inputType: 'date',
    },
    {
      field: 'fecha_recogo_docs',
      title: 'Fecha Recogo Docs',
      inputType: 'date',
    },
    {
      field: 'fecha_termino_embarque',
      title: 'Fecha Término Embarque',
      inputType: 'date',
    },
    { field: 'fecha_cierre', title: 'Fecha Cierre', inputType: 'date' },
    {
      field: 'numero_manifiesto',
      title: 'Número Manifiesto',
      inputType: 'text',
    },
    {
      field: 'manifiesto_desconsolidado',
      title: 'Manifiesto Desconsolidado',
      inputType: 'text',
    },
    {
      field: 'usuario_emite_statment',
      title: 'Usuario Emite Statement',
      inputType: 'text',
    },
    {
      field: 'fecha_emite_statment',
      title: 'Fecha Emite Statement',
      inputType: 'date',
    },
    {
      field: 'emitio_statment',
      title: 'Emitio Statement',
      inputType: 'checkbox',
    },
    {
      field: 'usuario_prefactura',
      title: 'Usuario PreFactura',
      inputType: 'text',
    },
    { field: 'fecha_prefactura', title: 'Fecha PreFactura', inputType: 'date' },
    {
      field: 'usuario_cierra_nave',
      title: 'Usuario Cierra Nave',
      inputType: 'text',
    },
    {
      field: 'fecha_cierra_nave',
      title: 'Fecha Cierra Nave',
      inputType: 'date',
    },
    { field: 'usuario_crea', title: 'Usuario Crea', inputType: 'text' },
    { field: 'fecha_crea', title: 'Fecha Crea', inputType: 'date' },
    { field: 'usuario_modifica', title: 'Usuario Modifica', inputType: 'text' },
    { field: 'fecha_modifica', title: 'Fecha Modifica', inputType: 'date' },
  ];

  datatableAuditoriaDetNaveViaje: any[] = [];
  metadataAuditoriaDetNaveViaje: newmetadate[] = [
    { field: 'operacion', title: 'Operación', inputType: 'text' },
    { field: 'direccion_ip', title: 'Dirección IP', inputType: 'text' },
    { field: 'nombre_maquina', title: 'Nombre Máquina', inputType: 'text' },
    {
      field: 'nombre_aplicacion',
      title: 'Nombre Aplicación',
      inputType: 'text',
    },
    { field: 'usuario_sql', title: 'Usuario SQL', inputType: 'text' },
    {
      field: 'usuario_aplicacion',
      title: 'Usuario Aplicación',
      inputType: 'text',
    },
    {
      field: 'fecha_modificacion',
      title: 'Fecha Modificación',
      inputType: 'date',
    },
    { field: 'cod_nave_viaje', title: 'CodNave Viaje', inputType: 'text' },
    { field: 'item', title: 'Item', inputType: 'text' },
    { field: 'item', title: 'Cod Puerto', inputType: 'text' },
    { field: 'fec_eta_etd', title: 'Fec ETA ETD', inputType: 'date' },
    { field: 'usuario_crea', title: 'Usuario Crea', inputType: 'text' },
    { field: 'fec_crea', title: 'Fec Crea', inputType: 'date' },
    { field: 'usuario_modifica', title: 'Usuario Modifica', inputType: 'text' },
    { field: 'fec_modifica', title: 'Fec Modifica', inputType: 'date' },
  ];

  async ngOnInit(): Promise<void> {
    try {
      this.group_edicion = new FormGroup({
        codigonvia: new FormControl({ value: null, disabled: true }, null), //nvia_codigo
        Via: new FormControl(null, Validators.required), //nvia_codigo
        Estado: new FormControl({ value: null, disabled: true }, null), //nvia_estado // es TRUE CAMBIAR disabled: true
        estado: new FormControl(null, null), //nvia_desestado
        Transportista: new FormControl(null, Validators.required), //n entc_codtransportista
        Regimen: new FormControl(null, Validators.required), //cons_codrgm
        NaveViaje: new FormControl(
          { value: null, disabled: true },
          Validators.required
        ), //nave_codigo
        codpuerto: new FormControl(null, null), //puer_codigo
        NVIA_NroViaje: new FormControl(
          { value: null, disabled: false },
          Validators.required
        ), //nvia_nroviaje
        feceta: new FormControl(null, null),
        etaactualizado: new FormControl(null, null),
        fecetd: new FormControl(null, null), // Fecha ETD nvia_feceta_impo_etd_expo
        Fecha_CutOff: new FormControl(null, null), // cutoff nvia_feccutoff_expo
        Llegada: new FormControl(null, null),
        viajefeeder: new FormControl(null, null),
        CierreDireccionamiento: new FormControl(null, null),
        FechaDescarga: new FormControl(null, null),
        Manifiesto: new FormControl(null, null),
        desconsolidado: new FormControl(null, null),
        TerminalPortuario: new FormControl(null, null),
        agente: new FormControl(null, null),
        AgentePortuario: new FormControl(null, null),
        plazovistobueno: new FormControl(null, null),
        plazovistobuenohoras: new FormControl(null, null),
        cierredireccionamientohoras: new FormControl(null, null),
        fechazarpe: new FormControl(null, null),
        agente2: new FormControl(null, null),
        fechaaviso: new FormControl(null, null),
        usrcreacion: new FormControl({ value: null, disabled: true }, null),
        feccreacion: new FormControl({ value: null, disabled: true }, null),
        usremitstatement: new FormControl({ value: null, disabled: true }, null),
        fecemitstatement: new FormControl({ value: null, disabled: true }, null),
        usrprefactura: new FormControl({ value: null, disabled: true }, null),
        fecprefactura: new FormControl({ value: null, disabled: true }, null),
        usrcierrenave: new FormControl({ value: null, disabled: true }, null),
        feccierrenave: new FormControl({ value: null, disabled: true }, null),
        FechaRecogoDocumentos: new FormControl(null, null),
        Horas_Fecha_CutOff: new FormControl(null, null),
        Llegada_orig: new FormControl(null, null),
      });

      const row = this.row;
      const adicional = row?.listadodatosadicionales?.length
        ? row.listadodatosadicionales[0]
        : null;
      this.datatableDetNaveViaje = row?.listadodetnaveviaje ?? [];
      this.datatableAuditoriaNaveViaje = row?.listadoauditorianaveviaje ?? [];
      this.datatableAuditoriaDetNaveViaje =
        row?.listadoauditoriadetnaveviaje ?? [];

      if (adicional) {
        if (adicional.nvia_feceta_impo_etd_expo_2) {
          this.group_edicion
            .get('etaactualizado')
            .setValue(new Date(adicional.nvia_feceta_impo_etd_expo_2));
        }
        if (adicional.nvia_fecllega_expo_zarpe_impo) {
          this.group_edicion
            .get('fechazarpe')
            .setValue(new Date(adicional.nvia_fecllega_expo_zarpe_impo));
        }
        if (adicional.nvia_fecllega_impo_zarpe_expo) {
          this.group_edicion
            .get('Llegada')
            .setValue(new Date(adicional.nvia_fecllega_impo_zarpe_expo));
          this.group_edicion
            .get('Llegada_orig')
            .setValue(new Date(adicional.nvia_fecllega_impo_zarpe_expo));
        }
        if (adicional.nvia_esfeeder) {
          this.group_edicion.get('viajefeeder').setValue(adicional.nvia_esfeeder);
        }
        if (adicional.nvia_feccutoff_expo) {
          this.group_edicion
            .get('Fecha_CutOff')
            .setValue(new Date(adicional.nvia_feccutoff_expo));
          const fecha = new Date(row.nvia_feccutoff_expo);
          const horas = fecha.getHours().toString().padStart(2, '0');
          const minutos = fecha.getMinutes().toString().padStart(2, '0');
          this.group_edicion
            .get('Horas_Fecha_CutOff')
            .setValue(`${horas}:${minutos}`);
        }
      }

      if (row) {
        if (row.nvia_estado) {
          this.group_edicion.get('Estado').setValue(row.nvia_estado);
          if (row.nvia_estado == 'P') {
            this.readonlyVia = true;
            // this.readonlyRegimen = true;
            this.readonlyPuerto = true;
            this.readonlyNroViaje = true;
            this.readonlyTransportista = true;
            this.group_edicion.get('Via')?.disable();
            this.group_edicion.get('Regimen')?.disable();
            this.group_edicion.get('codpuerto')?.disable();
            this.group_edicion.get('NVIA_NroViaje')?.disable();
            this.group_edicion.get('Transportista')?.disable();
          } else if (row.nvia_estado == 'C') {
            this.readonlyVia = true;
            // this.readonlyRegimen = true;
            this.readonlyPuerto = true;
            this.readonlyNroViaje = true;
            this.readonlyTransportista = true;
            this.readonlyEta = true;
            this.readonlyLlegada = true;
            this.readonlyDescarga = true;
            this.readonlyCierre = true;
            this.readonlyManifiesto = true;
            this.readonlyDesconsolidado = true;
            this.readonlyZarpe = true;
            this.readonlyTerminalPortuario = true;
            this.readonlyAgente = true;
            this.readonlyAgente2 = true;
            this.group_edicion.get('Via')?.disable();
            this.group_edicion.get('Regimen')?.disable();
            this.group_edicion.get('codpuerto')?.disable();
            this.group_edicion.get('feceta')?.disable();
            this.group_edicion.get('Llegada')?.disable();
            this.group_edicion.get('FechaDescarga')?.disable();
            this.group_edicion.get('CierreDireccionamiento')?.disable();
            this.group_edicion.get('cierredireccionamientohoras')?.disable();
            this.group_edicion.get('Manifiesto')?.disable();
            this.group_edicion.get('desconsolidado')?.disable();
            this.group_edicion.get('fechazarpe')?.disable();
            this.group_edicion.get('TerminalPortuario')?.disable();
            this.group_edicion.get('agente')?.disable();
            this.group_edicion.get('agente2')?.disable();
            this.group_edicion.get('NVIA_NroViaje')?.disable();
            this.group_edicion.get('Transportista')?.disable();
          }
        }
        if (row.nvia_codigo) {
          this.group_edicion.get('codigonvia').setValue(row.nvia_codigo);
        }
        if (row.cons_codvia) {
          this.group_edicion.get('Via').setValue(row.cons_codvia);
        }
        if (row.entc_codtransportista) {
          this.group_edicion
            .get('Transportista')
            .setValue(row.entc_codtransportista + '');
        }
        if (row.cons_codrgm) {
          this.group_edicion.get('Regimen').setValue(row.cons_codrgm);
        }
        if (row.nave_codigo) {
          this.group_edicion.get('NaveViaje').setValue(row.nave_codigo);
        }
        if (row.puer_codigo) {
          this.group_edicion.get('codpuerto').setValue(row.puer_codigo + '');
        }
        if (row.nvia_nroviaje) {
          this.group_edicion.get('NVIA_NroViaje').setValue(row.nvia_nroviaje);
        }
        if (row.nvia_feceta_impo_etd_expo) {
          this.group_edicion
            .get('feceta')
            .setValue(new Date(row.nvia_feceta_impo_etd_expo));
        }
        if (row.entc_fecrecogerdocs) {
          this.group_edicion
            .get('FechaRecogoDocumentos')
            .setValue(new Date(row.entc_fecrecogerdocs));
        }
        if (row.nvia_feccierredire_impo_termemba_expo) {
          this.group_edicion
            .get('CierreDireccionamiento')
            .setValue(new Date(row.nvia_feccierredire_impo_termemba_expo));
        }
        if (row.nvia_fecdescarga_impo) {
          this.group_edicion
            .get('FechaDescarga')
            .setValue(new Date(row.nvia_fecdescarga_impo));
        }
        if (row.nvia_nromanifiesto) {
          this.group_edicion.get('Manifiesto').setValue(row.nvia_nromanifiesto);
        }
        if (row.nvia_normanifiestodescon) {
          this.group_edicion
            .get('desconsolidado')
            .setValue(row.nvia_normanifiestodescon);
        }
        if (row.cod_terminal_portuario) {
          this.group_edicion
            .get('TerminalPortuario')
            .setValue(row.cod_terminal_portuario.toString());
        }
        if (row.entc_codagenportvobo_impo) {
          this.group_edicion
            .get('agente')
            .setValue(row.entc_codagenportvobo_impo.toString());
        }
        if (row.cod_agente_portuario) {
          this.group_edicion
            .get('AgentePortuario')
            .setValue(row.cod_agente_portuario.toString());
        }
        if (row.entc_codagenportvobo2_impo) {
          this.group_edicion
            .get('agente2')
            .setValue(row.entc_codagenportvobo2_impo.toString());
        }
        if (row.nvia_fecplazovistobueno) {
          this.group_edicion
            .get('plazovistobueno')
            .setValue(new Date(row.nvia_fecplazovistobueno));
        }
        if (row.nvia_fecplazovistobueno) {
          const fecha = new Date(row.nvia_fecplazovistobueno);
          const horas = fecha.getHours().toString().padStart(2, '0');
          const minutos = fecha.getMinutes().toString().padStart(2, '0');
          this.group_edicion
            .get('plazovistobuenohoras')
            .setValue(`${horas}:${minutos}`);
        }
        if (row.nvia_feccierredire_impo_termemba_expo) {
          const fecha = new Date(row.nvia_feccierredire_impo_termemba_expo);
          const horas = fecha.getHours().toString().padStart(2, '0');
          const minutos = fecha.getMinutes().toString().padStart(2, '0');
          this.group_edicion
            .get('cierredireccionamientohoras')
            .setValue(`${horas}:${minutos}`);
        }
        if (row.nvia_feceta_zarpe) {
          this.group_edicion
            .get('fechaaviso')
            .setValue(new Date(row.nvia_feceta_zarpe));
        } // ??
        if (row.audi_usrcrea) {
          this.group_edicion.get('usrcreacion').setValue(row.audi_usrcrea);
          this.usrcreacion = row.audi_usrcrea;
        }
        if (row.audi_feccrea) {
          this.group_edicion
            .get('feccreacion')
            .setValue(new Date(row.audi_feccrea));
          this.feccreacion = this.util.formatearfecha(
            row.audi_feccrea,
            'dd/mm/yyyy'
          );
        }
        if (row.nvia_usremitestatment) {
          this.group_edicion
            .get('usremitstatement')
            .setValue(row.nvia_usremitestatment);
          this.usremitestatemnt = row.nvia_usremitestatment;
        }
        if (row.nvia_fecemitestatment) {
          this.group_edicion
            .get('fecemitstatement')
            .setValue(new Date(row.nvia_fecemitestatment));
          this.fecemitestatemnt = this.util.formatearfecha(
            row.nvia_fecemitestatment,
            'dd/mm/yyyy'
          );
        }
        if (row.nvia_usrprefactura) {
          this.group_edicion
            .get('usrprefactura')
            .setValue(row.nvia_usrprefactura);
          this.usrprefactura = row.nvia_usrprefactura;
        }
        if (row.nvia_fecprefactura) {
          this.group_edicion
            .get('fecprefactura')
            .setValue(
              new Date(
                this.util.formatearfecha(
                  row.nvia_fecprefactura,
                  'yyyy-MM-ddTHH:mm:ss'
                )
              )
            );
          this.fecprefactura = this.util.formatearfecha(
            row.nvia_fecprefactura,
            'dd/mm/yyyy'
          );
        }
        if (row.nvia_usrcierrenave) {
          this.group_edicion
            .get('usrcierrenave')
            .setValue(row.nvia_usrcierrenave);
          this.usrcerrarnave = row.nvia_usrcierrenave;
        }
        if (row.nvia_feccierrenave) {
          this.group_edicion
            .get('feccierrenave')
            .setValue(new Date(row.nvia_feccierrenave));
          this.feccerrarnave = this.util.formatearfecha(
            row.nvia_feccierrenave,
            'dd/mm/yyyy'
          );
        }
        if (row.btn_archivos) {
          this.btn_archivos = row.btn_archivos;
        }
        if (row.btn_email_almacen) {
          this.btn_email_almacen = row.btn_ebtn_email_almacenails;
        }
        if (row.btn_email_cancelacion_recalada) {
          this.btn_email_cancelacion_recalada =
            row.btn_email_cancelacion_recalada;
        }
        if (row.btn_email_demora_arribo) {
          this.btn_email_demora_arribo = row.btn_email_demora_arribo;
        }
        if (row.btn_email_emitir_bl) {
          this.btn_email_emitir_bl = row.btn_email_emitir_bl;
        }
        if (row.btn_email_aviso_llegada) {
          this.btn_email_aviso_llegada = row.btn_email_aviso_llegada;
        }
        if (row.btn_email_carga_tarjada_lcl) {
          this.btn_email_carga_tarjada_lcl = row.btn_email_carga_tarjada_lcl;
        }
        if (row.btn_email_carga_tarjada_fcl) {
          this.btn_email_carga_tarjada_fcl = row.btn_email_carga_tarjada_fcl;
        }
        if (row.btn_archivo_direccionamiento) {
          this.btn_archivo_direccionamiento = row.btn_archivo_direccionamiento;
        }
        if (row.btn_archivo_vobo) {
          this.btn_archivo_vobo = row.btn_archivo_vobo;
        }
      }
      switch (this.tipo) {
        case 'U': //EDITAR
          this.esEditar = true;
          this.onRegimenChange(0, 'INI');
          this.onViaChange(0, 'INI');
          break;
        case 'I': //CREAR
          this.group_edicion.get('Estado').setValue('A');
          this.group_edicion.get('codigonvia').setValue(0);
          this.group_edicion.get('cierredireccionamientohoras').setValue('00:00');
          this.group_edicion.get('Horas_Fecha_CutOff').setValue('00:00');
          this.group_edicion.get('plazovistobuenohoras').setValue('00:00');
          this.esEditar = false;
          // this.onViaChange(0, 'INI');
          // via
          this.esMaritimo = false;
          this.esAereo = false;
          this.esTerrestre = false;
          this.esFluvial = false;
          this.readonlyNave = true;
          this.ListaTodosNave = [];
          // regimen
          this.esInicial = false;
          this.esImportacion = false;
          this.esExportacion = false;
          break;
      }

      if (this.origen === 'orden_venta') {
        if (this.tipo == 'U') {
          this.btn_guardar = true;
        } else if (this.tipo == 'I') {
          this.validateFeederFinal(row.puer_codigo, 'INI');
        }

        this.group_edicion
          .get('Transportista')
          .setValue(this.dataordenventa?.entc_codtransportista?.toString());
        this.group_edicion
          .get('Via')
          .setValue(this.dataordenventa?.cons_codvia?.toString());
        this.group_edicion
          .get('Regimen')
          .setValue(this.dataordenventa?.cons_codrgm?.toString());

        const eventoRegimen = {
          value: this.dataordenventa?.cons_codrgm?.toString(),
        };
        const eventoVia = {
          value: this.dataordenventa?.cons_codvia?.toString(),
        };
        this.onRegimenChange(eventoRegimen, 'EVE');
        this.onViaChange(eventoVia, 'EVE');
      }
    } catch (err) {
      console.error("Error en ngOnInit", err);
    }
  }

  stateOptions: any[] = [
    // { label: 'Guardar', value: 'G', icon: "pi pi-save" }, { label: 'Salir', value: 'S', icon: "pi pi-times" }
    {
      label: 'Emitir Statement',
      value: 'ES',
      icon: 'pi pi-file-check',
      disabled: false,
    },
    {
      label: 'Aprobar Statemenet',
      value: 'APS',
      icon: 'pi pi pi-check',
      disabled: false,
    },
    {
      label: 'Abrir Statement',
      value: 'ABS',
      icon: 'pi pi-folder-open',
      disabled: false,
    },
    {
      label: 'Cerrar Nave',
      value: 'CN',
      icon: 'pi pi-times-circle',
      disabled: false,
    },
    {
      label: 'Archivos',
      value: 'AR',
      icon: 'pi pi-file-export',
      disabled: false,
    },
    {
      label: "'Email's'",
      value: 'EM',
      icon: 'pi pi-envelope',
      disabled: false,
    },
    { label: 'Auditoria', value: 'AU', icon: 'pi pi-user' },
  ];

  archivositems = [
    {
      label: 'Direccionamiento',
      command: () => {
        this.archivosFuncion('D');
      },
      disable: !this.btn_archivo_direccionamiento,
    },
    {
      label: 'Carga de desglose de VoBo',
      command: () => {
        this.archivosFuncion('VoBo');
      },
      disable: !this.btn_archivo_vobo,
    },
  ];
  emailitems = [
    {
      label: 'Email a los Almacenes',
      command: () => {
        this.emailFuncion('A');
      },
      disable: !this.btn_email_almacen,
    },
    {
      label: 'Email por Cancelación de Recalada',
      command: () => {
        this.emailFuncion('CR');
      },
      disable: !this.btn_email_cancelacion_recalada,
    },
    {
      label: 'Email por Demora en Arribo',
      command: () => {
        this.emailFuncion('DA');
      },
      disable: !this.btn_email_demora_arribo,
    },
    {
      label: 'Avisos de Llegada',
      command: () => {
        this.emailFuncion('L');
      },
      disable: !this.btn_email_aviso_llegada,
    },
    {
      label: 'Carga Tarjada LCL',
      command: () => {
        this.emailFuncion('LCL');
      },
      disable: !this.btn_email_carga_tarjada_lcl,
    },
    {
      label: 'Carga Tarjada FCL',
      command: () => {
        this.emailFuncion('FCL');
      },
      disable: !this.btn_email_carga_tarjada_fcl,
    },
  ];

  opcionesBotones(event: any) {
    console.log(event);

    if (event !== null && event !== undefined) {
      switch (event.option.value) {
        case 'G':
          this.transaccionNaveViaje('U');
          break;
        case 'S':
          this.salir();
          break;
        case 'ES':
          break;
        case 'APS':
          break;
        case 'ABS':
          break;
        case 'CN':
          break;
        case 'AR':
          break;
        case 'EM':
          break;
        case 'AU':
          break;
        default:
          break;
      }
    }
  }

  lblNroViaje: string = 'Nro Viaje';
  lblFecLLegaImpo_Z_Expo: string = 'Fec. Llegada';
  lblFecLLegaExpo_Z_Impo: string = 'Fec. Zarpe';
  esMaritimo: boolean = false;
  esAereo: boolean = false;
  esTerrestre: boolean = false;
  esFluvial: boolean = false;
  readonlyNave: boolean = false;
  onViaChange(event: any, valor: string) {
    let value;
    let rgm;
    if (valor === 'EVE') {
      value = event.value;
      rgm = this.group_edicion.get('Regimen')?.value
    } else if (valor === 'INI') {
      value = this.row.cons_codvia;
      rgm = this.row.cons_codrgm;
    } else {
      value = '';
      rgm = ''
    }
    //PARA IMPO:
    if (rgm === '001') {
      switch (value) {
        case '001':
          this.esMaritimo = true;
          this.esAereo = false;
          this.esTerrestre = false;
          this.esFluvial = false;
          this.lblNroViaje = 'Nro Viaje';
          this.lblFecLLegaImpo_Z_Expo = 'Fec. Llegada';
          this.lblFecLLegaExpo_Z_Impo = 'Fec. Zarpe';
          this.readonlyNave = false;
          this.group_edicion.get('NaveViaje')?.enable();
          this.mostrarHoraLlegada = true; // 👈 Mostrar hora
          break;
        case '002':
          this.esMaritimo = false;
          this.esAereo = true;
          this.esTerrestre = false;
          this.esFluvial = false;
          this.lblNroViaje = 'Nro. Vuelo';
          this.lblFecLLegaImpo_Z_Expo = 'Fec. de Vuelo';
          this.lblFecLLegaExpo_Z_Impo = 'Fec. Llegada Vuelo';
          this.readonlyNave = false;
          this.group_edicion.get('NaveViaje')?.enable();
          this.mostrarHoraLlegada = true; // 👈 No mostrar hora
          break;
        case '003':
          this.esMaritimo = false;
          this.esAereo = false;
          this.esTerrestre = true;
          this.esFluvial = false;
          this.lblNroViaje = 'Nro Viaje';
          this.lblFecLLegaImpo_Z_Expo = 'Fec. Llegada';
          this.lblFecLLegaExpo_Z_Impo = 'Fec. Zarpe';
          this.readonlyNave = true;
          this.group_edicion.get('NaveViaje')?.disable();
          this.mostrarHoraLlegada = true; //No existen en estos campos, pero lo dejamos en true
          break;
        case '004':
          this.esMaritimo = false;
          this.esAereo = false;
          this.esTerrestre = false;
          this.esFluvial = true;
          this.lblNroViaje = 'Nro Viaje';
          this.lblFecLLegaImpo_Z_Expo = 'Fec. Llegada';
          this.lblFecLLegaExpo_Z_Impo = 'Fec. Zarpe';
          this.readonlyNave = true;
          this.group_edicion.get('NaveViaje')?.disable();
          this.mostrarHoraLlegada = true; //No existen en estos campos, pero lo dejamos en true
          break;
        default:
          this.esMaritimo = false;
          this.esAereo = false;
          this.esTerrestre = false;
          this.esFluvial = false;
          this.readonlyNave = true;
          this.group_edicion.get('NaveViaje')?.disable();
          this.mostrarHoraLlegada = false;
          break;
      }
    } else if (rgm === '002') {
      //PARA EXPO:
      switch (value) {
        case '001':
          this.esMaritimo = true;
          this.esAereo = false;
          this.esTerrestre = false;
          this.esFluvial = false;
          this.lblNroViaje = 'Nro Viaje';
          this.lblFecLLegaImpo_Z_Expo = 'Fec. Arribo';
          this.lblFecLLegaExpo_Z_Impo = 'Fec. Zarpe';
          this.readonlyNave = false;
          this.group_edicion.get('NaveViaje')?.enable();
          this.mostrarHoraLlegada = false; // 👈 No mostrar hora
          break;
        case '002':
          this.esMaritimo = false;
          this.esAereo = true;
          this.esTerrestre = false;
          this.esFluvial = false;
          this.lblNroViaje = 'Nro. Vuelo';
          this.lblFecLLegaImpo_Z_Expo = 'Fec. de Vuelo';
          this.lblFecLLegaExpo_Z_Impo = 'Fec. Llegada Vuelo';
          this.readonlyNave = false;
          this.group_edicion.get('NaveViaje')?.enable();
          this.mostrarHoraLlegada = false; // 👈 No mostrar hora
          break;
        case '003':
          this.esMaritimo = false;
          this.esAereo = false;
          this.esTerrestre = true;
          this.esFluvial = false;
          this.lblNroViaje = 'Nro Viaje';
          this.lblFecLLegaImpo_Z_Expo = 'Fec. Arribo';
          this.lblFecLLegaExpo_Z_Impo = 'Fec. Zarpe';
          this.readonlyNave = true;
          this.group_edicion.get('NaveViaje')?.disable();
          this.mostrarHoraLlegada = false;
          break;
        case '004':
          this.esMaritimo = false;
          this.esAereo = false;
          this.esTerrestre = false;
          this.esFluvial = true;
          this.lblNroViaje = 'Nro Viaje';
          this.lblFecLLegaImpo_Z_Expo = 'Fec. Llegada';
          this.lblFecLLegaExpo_Z_Impo = 'Fec. Zarpe';
          this.readonlyNave = true;
          this.group_edicion.get('NaveViaje')?.disable();
          this.mostrarHoraLlegada = false;
          break;
        default:
          this.esMaritimo = false;
          this.esAereo = false;
          this.esTerrestre = false;
          this.esFluvial = false;
          this.readonlyNave = true;
          this.group_edicion.get('NaveViaje')?.disable();
          this.mostrarHoraLlegada = false;
          break;
      }
    }
    const lista = structuredClone(this.ListaTodasNaves);
    this.ListaTodosNave = lista.filter((r) => r.cons_codvia === value);
    const listaPuertos = structuredClone(this.ListaTodosPuerto);
    this.ListaPuertosFiltrados = listaPuertos.filter((r) => r.via === value);
  }

  esInicial: boolean = false;
  lblPuerto: string = 'Puerto Destino';
  lblFecETDETA: string = 'Fecha ETA';
  lblFecCierreDirecc: string = 'Fec Cierre Direc.';
  esImportacion: boolean = false;
  esExportacion: boolean = false;
  mostrarHoraLlegada: boolean = false;

  onRegimenChange(event: any, valor: string) {
    let value;
    if (valor === 'EVE') {
      value = event.value;
    } else if (valor === 'INI') {
      value = this.row.cons_codrgm;
    } else {
      value = '';
    }
    switch (value) {
      case '001':
        this.readonlyVia = false;
        this.esInicial = true;
        this.lblPuerto = 'Puerto Destino';
        this.lblFecETDETA = 'Fecha ETA';
        this.lblFecCierreDirecc = 'Fec Cierre Direc.';
        this.lblFecLLegaImpo_Z_Expo = 'Fec. Llegada';
        this.lblFecLLegaExpo_Z_Impo = 'Fec. Zarpe';
        this.mostrarHoraLlegada = true; // 👈 Mostrar hora
        this.esImportacion = true;
        this.esExportacion = false;
        break;
      case '002':
        this.readonlyVia = false;
        this.esInicial = true;
        this.lblPuerto = 'Puerto Origen';
        this.lblFecETDETA = 'Fecha ETD';
        this.lblFecCierreDirecc = 'Fec Ter. Emb.';
        this.lblFecLLegaImpo_Z_Expo = 'Fec. Zarpe';
        this.lblFecLLegaExpo_Z_Impo = 'Fec. Arribo';
        this.mostrarHoraLlegada = false;
        this.esImportacion = false;
        this.esExportacion = true;
        break;
      default:
        this.esInicial = false;
        this.mostrarHoraLlegada = false;
        this.esImportacion = false;
        this.esExportacion = false;
        break;
    }
  }

  onNaveChange(event: any, valor: string) {
    let value = event.value;
    if (value != null) {
      const lista = structuredClone(this.ListaTodasNaves);
      const objNave = lista.filter((r) => r.nave_codigo === value);
      value = objNave[0].nave_nombre;
    }
    this.group_edicion.get('NVIA_NroViaje').setValue(value);
  }

  formatCustomInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    let value = input.value.replace(/[^0-9]/g, '');
    if (value.length > 4) {
      value = `${value.substring(0, 4)}-${value.substring(4)}`;
    }
    input.value = value.substring(0, 11);
  }

  formatTime(event: Event): void {
    const input = event.target as HTMLInputElement;
    let value = input.value.replace(/[^0-9]/g, '');
    if (value.length > 2) {
      value = `${value.substring(0, 2)}:${value.substring(2)}`;
    }
    input.value = value.substring(0, 5);
  }

  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }

  salir() {
    this.reference.close();
  }

  esCerrado: boolean = false;
  esRGM002Expo: boolean = false;
  esVIA002: boolean = false;
  esVIA001: boolean = false;
  esRGM001Impo: boolean = false;
  noesVIA002: boolean = false;
  valfec001: boolean = false;
  valfec002: boolean = false;
  valfec003: boolean = false;
  valfec004: boolean = false;
  valfec005: boolean = false;
  valfec006: boolean = false;
  valfec007: boolean = false;
  valfec008: boolean = false;

  async validaciones(): Promise<boolean> {
    if (this.group_edicion.invalid) {
      this.group_edicion.markAllAsTouched();
      this.cdRef.detectChanges();
    }

    let camposFaltantes: string[] = [],
      mensajesDirectos: string[] = [],
      mensaje;
    const fecetaControl = this.group_edicion.get('feceta');
    const cierreControl = this.group_edicion.get('CierreDireccionamiento');
    const llegadaControl = this.group_edicion.get('Llegada');
    const feccutoffControl = this.group_edicion.get('Fecha_CutOff');
    const agentePortuarioControl = this.group_edicion.get('AgentePortuario');
    const FechaRecogoDocumentosControl = this.group_edicion.get(
      'FechaRecogoDocumentos'
    );
    const codRegimen = this.group_edicion.get('Regimen')?.value;
    const descargaControl = this.group_edicion.get('FechaDescarga');
    const codVia = this.group_edicion.get('Via')?.value;
    const fechaLlegada = new Date(llegadaControl.value);
    const fechaDescarga = new Date(descargaControl.value);
    const desconsolidadoControl = this.group_edicion.get('desconsolidado');
    Object.keys(this.group_edicion.controls).forEach((key) => {
      if (this.group_edicion.get(key)?.invalid) {
        camposFaltantes.push(key);
      }
    });

    const codEstado = this.group_edicion.get('Estado')?.value;
    if (codEstado === 'C') {
      this.esCerrado = true;
      const camposAValidar = ['Manifiesto', 'TerminalPortuario'];

      camposAValidar.forEach((campo) => {
        const control = this.group_edicion.get(campo);
        if (!control?.value) {
          camposFaltantes.push(campo);
          control?.markAsTouched();
        }
      });

      const camposRegimen002 = [
        { key: 'Llegada', label: this.lblFecLLegaImpo_Z_Expo },
        { key: 'CierreDireccionamiento', label: this.lblFecCierreDirecc },
      ];

      camposRegimen002.forEach(({ key, label }) => {
        const control = this.group_edicion.get(key);
        if (!control?.value) {
          camposFaltantes.push(label);
          control?.markAsTouched();
        }
      });

      if (codRegimen === '002') {
        this.esRGM002Expo = true;

        if (
          cierreControl?.value &&
          llegadaControl?.value &&
          cierreControl.value >= llegadaControl.value
        ) {
          mensajesDirectos.push(
            this.lblFecLLegaImpo_Z_Expo +
            ' debe ser menor o igual a ' +
            this.lblFecCierreDirecc +
            '\n'
          );
          cierreControl.markAsTouched();
          this.valfec001 = true;
        } else {
          this.valfec001 = false;
        }

        if (codVia === '002') {
          this.esVIA002 = true;

          if (!fecetaControl?.value) {
            camposFaltantes.push(this.lblFecETDETA);
            fecetaControl?.markAsTouched();
          }
          if (!feccutoffControl?.value) {
            camposFaltantes.push('Fecha_CutOff');
            feccutoffControl?.markAsTouched();
          }
          if (!agentePortuarioControl?.value) {
            camposFaltantes.push('AgentePortuario');
            agentePortuarioControl?.markAsTouched();
          }
          if (!FechaRecogoDocumentosControl?.value) {
            camposFaltantes.push('FechaRecogoDocumentos');
            FechaRecogoDocumentosControl?.markAsTouched();
          }

          if (
            fecetaControl?.value &&
            cierreControl?.value &&
            fecetaControl.value >= cierreControl.value
          ) {
            mensajesDirectos.push(
              this.lblFecETDETA + ' debe ser menor a ' + this.lblFecCierreDirecc
            );
            fecetaControl.markAsTouched();
            this.valfec002 = true;
          } else {
            this.valfec002 = false;
          }

          if (
            llegadaControl?.value &&
            fecetaControl?.value &&
            llegadaControl.value > fecetaControl.value
          ) {
            mensajesDirectos.push(
              this.lblFecLLegaImpo_Z_Expo +
              ' debe ser menor o igual que ' +
              this.lblFecETDETA
            );
            llegadaControl.markAsTouched();
            this.valfec003 = true;
          } else {
            this.valfec003 = false;
          }

          if (
            feccutoffControl?.value &&
            fecetaControl?.value &&
            feccutoffControl.value >= fecetaControl.value
          ) {
            mensajesDirectos.push(
              'Fecha CutOff debe ser menor a ' + this.lblFecETDETA
            );
            feccutoffControl.markAsTouched();
            this.valfec004 = true;
          } else {
            this.valfec004 = false;
          }

          if (
            FechaRecogoDocumentosControl?.value &&
            llegadaControl?.value &&
            FechaRecogoDocumentosControl.value <= llegadaControl.value
          ) {
            mensajesDirectos.push(
              'Fecha Recogo Docs debe ser mayor a ' +
              this.lblFecLLegaImpo_Z_Expo
            );
            FechaRecogoDocumentosControl.markAsTouched();
            this.valfec005 = true;
          } else {
            this.valfec005 = false;
          }
        } else {
          this.esVIA002 = false;
        }
      } else {
        this.esRGM002Expo = false;
      }
      if (codRegimen === '001') {
        this.esRGM001Impo = true;
        if (
          llegadaControl?.value &&
          fecetaControl?.value &&
          llegadaControl.value <= fecetaControl.value
        ) {
          mensajesDirectos.push(
            this.lblFecLLegaImpo_Z_Expo +
            ' debe ser mayor o igual que ' +
            this.lblFecETDETA
          );
          llegadaControl.markAsTouched();
          this.valfec006 = true;
        } else {
          this.valfec006 = false;
        }

        const camposAValidar = ['FechaDescarga'];

        camposAValidar.forEach((campo) => {
          const control = this.group_edicion.get(campo);
          if (!control?.value) {
            camposFaltantes.push(campo);
            control?.markAsTouched();
          }
        });

        if (llegadaControl?.value && descargaControl?.value) {
          const diferenciaDias =
            (fechaDescarga.getTime() - fechaLlegada.getTime()) /
            (1000 * 60 * 60 * 24);
          if (diferenciaDias > 10) {
            mensajesDirectos.push(
              'La Fec. Descarga debe ser mayor como máximo en 10 días a la Fec. de Llegada'
            );
            descargaControl.markAsTouched();
            this.valfec007 = true;
          } else {
            this.valfec007 = false;
          }
        }

        if (codVia != '002') {
          this.noesVIA002 = true;
          if (cierreControl?.value && llegadaControl?.value) {
            if (
              cierreControl.value >= fecetaControl.value ||
              cierreControl.value >= fechaLlegada ||
              cierreControl.value >= fechaDescarga.getTime()
            ) {
              mensajesDirectos.push(
                this.lblFecCierreDirecc +
                ' debe ser menor a las fechas (ETA, Descarga, Llegada) ' +
                '\n'
              );
              cierreControl.markAsTouched();
              this.valfec008 = true;
            } else {
              this.valfec008 = false;
            }
          }
          if (!desconsolidadoControl?.value) {
            camposFaltantes.push('Manifiesto Desconsolidado');
            desconsolidadoControl?.markAsTouched();
          }
          if (!agentePortuarioControl?.value) {
            camposFaltantes.push('AgentePortuario');
            agentePortuarioControl?.markAsTouched();
          }
        } else {
          this.noesVIA002 = false;
        }
      } else {
        this.esRGM001Impo = false;
      }
    } else {
      this.esCerrado = false;
    }

    this.cdRef.detectChanges();

    if (camposFaltantes.length > 0 || mensajesDirectos.length > 0) {
      let detallesCampos = camposFaltantes.map(
        (campo) => `Debe ingresar el campo: ${campo}\n`
      );
      let detallesMensajes = [...detallesCampos, ...mensajesDirectos].join(
        '\n'
      );
      mensaje =
        camposFaltantes.length === 1
          ? `Debe ingresar el campo: ${camposFaltantes[0]}`
          : 'Ver Detalle de los Campos faltantes';

      return false;
    }
    return true;
  }

  formatDateTime(date: string | Date, time: string | Date): string {
    if (!date || !time) return null;

    const fecha = new Date(date);

    if (isNaN(fecha.getTime())) {
      throw new Error('Fecha inválida');
    }

    let horas = 0;
    let minutos = 0;
    let segundos = 0;

    // Si es formato HH:mm
    if (typeof time === 'string' && /^\d{2}:\d{2}$/.test(time)) {
      const [hh, mm] = time.split(':').map(Number);
      horas = hh;
      minutos = mm;
    } else {
      // Asumir que es Date o string completo parseable
      const hora = new Date(time);
      if (isNaN(hora.getTime())) {
        throw new Error('Hora inválida');
      }
      horas = hora.getHours();
      minutos = hora.getMinutes();
      segundos = hora.getSeconds();
    }

    // Asignar la hora a la fecha
    fecha.setHours(horas);
    fecha.setMinutes(minutos);
    fecha.setSeconds(segundos);

    // Formatear
    const year = fecha.getFullYear();
    const month = String(fecha.getMonth() + 1).padStart(2, '0');
    const day = String(fecha.getDate()).padStart(2, '0');
    const hour = String(fecha.getHours()).padStart(2, '0');
    const minute = String(fecha.getMinutes()).padStart(2, '0');
    const second = String(fecha.getSeconds()).padStart(2, '0');

    return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
  }

  aprobarCambioTransportista: string = null;
  async transaccionNaveViaje(ope: string) {
    if (this.group_edicion.get('codigonvia').value == 0) {
      ope = 'I';
    } else {
      ope = 'U';
    }
    const esValido = await this.validaciones();
    if (!esValido) return;
    const request = <TNSNaveViajeRequest>{};
    request.tablanaveviaje = [];
    request.aprobarCambioTransportista = this.aprobarCambioTransportista;
    let fecetc;
    if (this.group_edicion.value['Regimen'] == '002') {
      fecetc = this.group_edicion.value['feceta'] ?? null;
    } else {
      fecetc = null;
    }
    const group = this.group_edicion.value;

    // const cierredirec = this.formatDateTime(group["CierreDireccionamiento"], group["cierredireccionamientohoras"]);
    const cierredirec = this.formatDateToSQL(group['CierreDireccionamiento']);
    const cutoff = this.formatDateTime(
      group['Fecha_CutOff'],
      group['Horas_Fecha_CutOff']
    );
    // const plazovb = this.formatDateTime(group["plazovistobueno"], group["plazovistobuenohoras"]);
    const plazovb = this.formatDateToSQL(group['plazovistobueno']);

    const tablaNV = <TablaNaveViajeTNS>{};
    tablaNV.nvia_codigo = this.group_edicion.get('codigonvia').value;
    tablaNV.nvia_nroviaje = this.group_edicion.get('NVIA_NroViaje').value;
    tablaNV.nvia_feceta_impo_etd_expo = this.formatDateToSQL(
      this.group_edicion.get('feceta')?.value
    );
    tablaNV.entc_codagenteport_expo =
      this.group_edicion.get('AgentePortuario').value;
    tablaNV.entc_codtransportista =
      this.group_edicion.get('Transportista').value;
    tablaNV.nave_codigo = this.group_edicion.get('NaveViaje').value;
    tablaNV.audi_usrmod = this.nomUsuario;
    tablaNV.nvia_feccutoff_expo = cutoff;
    tablaNV.puer_codigo = this.group_edicion.get('codpuerto').value;
    tablaNV.tipo_tabtrf = null;
    tablaNV.tipo_codtrf = null;
    tablaNV.cons_tabrgm = 'RGM';
    tablaNV.cons_codrgm = this.group_edicion.get('Regimen').value;
    tablaNV.entc_codtermport =
      this.group_edicion.get('TerminalPortuario').value;
    tablaNV.nvia_feccierre = this.formatDateToSQL(
      this.group_edicion.get('feccierrenave')?.value
    );
    // const fechaLlegada = new Date(this.group_edicion.get("Llegada").value)
    // const fechaFormateada = this.util.formatearfecha(fechaLlegada, 'yyyy-MM-ddTHH:mm:ss.SS');

    tablaNV.nvia_fecllega_impo_zarpe_expo = this.formatDateToSQL(
      this.group_edicion.get('Llegada')?.value
    );
    tablaNV.nvia_fecllega_expo_zarpe_impo = this.formatDateToSQL(
      this.group_edicion.get('fechazarpe')?.value
    );
    tablaNV.cons_tabvia = 'VIA';
    tablaNV.cons_codvia = this.group_edicion.get('Via').value;
    tablaNV.nvia_estado = this.group_edicion.get('Estado').value;
    tablaNV.nvia_feccierredire_impo_termemba_expo = cierredirec;
    tablaNV.nvia_fecdescarga_impo = this.formatDateToSQL(
      this.group_edicion.get('FechaDescarga')?.value
    );
    tablaNV.entc_codagenportvobo_impo = this.group_edicion.get('agente').value;
    tablaNV.entc_codagenportvobo2_impo =
      this.group_edicion.get('agente2').value;
    tablaNV.entc_fecrecogerdocs = this.formatDateToSQL(
      this.group_edicion.get('FechaRecogoDocumentos')?.value
    );
    tablaNV.nvia_usrprefactura = this.group_edicion.get('usrprefactura').value;
    tablaNV.nvia_fecprefactura = this.group_edicion.get('fecprefactura').value;
    tablaNV.nvia_usrcierrenave = this.group_edicion.get('usrcierrenave').value;
    tablaNV.nvia_feccierenave = this.formatDateToSQL(
      this.group_edicion.get('feccierrenave')?.value
    );
    tablaNV.nvia_nromanifiesto = this.group_edicion.get('Manifiesto').value;
    tablaNV.nvia_normanifiestodescon =
      this.group_edicion.get('desconsolidado').value;
    tablaNV.nvia_fecplazovistobueno = plazovb;
    tablaNV.nvia_feceta_impo_etd_expo_2 = this.formatDateToSQL(
      this.group_edicion.get('etaactualizado')?.value
    );
    tablaNV.nvia_esfeeder = this.group_edicion.get('viajefeeder').value;
    tablaNV.nvia_fecetd = fecetc;

    request.tablanaveviaje.push(tablaNV);
    request.ope = ope;

    // return
    this.mantenimientorepository.TNSNaveViaje(request).subscribe((res) => {
      if (res.datos.status === 200) {
        if (this.tipo === 'U') {
          this.util.MessageDialog({
            titulo: 'NAVE VIAJE',
            mensaje: 'Se actualizó la Nave Viaje con éxito',
            icono: 'ok',
            tipo: 'ok',
          });
        } else if (this.tipo === 'I') {
          this.util.MessageDialog({
            titulo: 'NAVE VIAJE',
            mensaje: 'Se generó la Nave Viaje con éxito',
            icono: 'ok',
            tipo: 'ok',
          });
        }
        if (this.origen === 'orden_venta') {

          const datosNaveItinerario = {
            // nvia_esfeeder: this.group_edicion.get("viajefeeder").value,
            // codigoviaje: res.datos.Codigo,
            // nombrenave: this.group_edicion.get("NaveViaje").value,
            // viaje_vuelo: this.group_edicion.get("NVIA_NroViaje").value,
            // eta_etd: this.group_edicion.get("etaactualizado").value,
            // puerto: null,
            // puertoOrigen: this.group_edicion.get("codpuerto").value

            nvia_esfeeder: this.group_edicion.get('viajefeeder').value,
            codigoviaje: res.datos.codigo,
            nombrenave: this.group_edicion.get('NaveViaje').value,
            viaje_vuelo: this.group_edicion.get('NVIA_NroViaje').value || null,
            eta_etd:
              this.group_edicion.get('etaactualizado').value != null
                ? new Date(this.group_edicion.get('etaactualizado').value)
                : null,
            puerto: {
              label:
                this.ListaPuertosFiltrados.find(
                  (r) => (r.codigo = this.group_edicion.get('codpuerto').value)
                ).nombre || null,
              value: this.group_edicion.get('codpuerto').value || null,
            },
            puertoOrigen: null,
            valuePuerto: null,
            codPuerto: null,
          };
          this.reference.close({ message: 'OK', code: res.datos.codigo });
        } else {
          this.reference.close('OK');
        }
        this.dataUpdated.emit('OK');
      } else {
        if (res.datos.detalle) {
          this.util.MessageDialog({
            titulo: 'GUARDAR NAVE',
            mensaje: res.meta.mensaje,
            detalle: res.datos.detalle,
            tipo: 'warning',
            icono: 'pi pi-exclamation-triangle',
            pregunta: {
              onAccept: () => {
                this.aprobarCambioTransportista = 'SI';
                this.transaccionNaveViaje(ope);
              },
              onReject: () => {
                this.aprobarCambioTransportista = 'NO';
                this.transaccionNaveViaje(ope);
              },
            },
          });
        } else {
          this.util.MessageDialog({
            titulo: 'ERROR',
            mensaje: res.meta.mensaje,
            icono: 'pi pi-exclamation-triangle',
            tipo: 'warning',
          });
        }
      }
    });
  }

  customAuditoria = [
    {
      icon: 'pi pi-file-excel',
      function: () => this.exportarAuditoriaNV(),
      toolTip: 'Exportar Excel',
      loading: false,
    },
  ];
  customDetAuditoria = [
    {
      icon: 'pi pi-file-excel',
      function: () => this.exportarAuditoriaDetNV(),
      toolTip: 'Exportar Excel',
      loading: false,
    },
  ];

  exportarAuditoriaNV() {
    if (this.datatableAuditoriaNaveViaje.length == 0) {
      this.util.showMessageError('No hay campos para exportar');
      return;
    }
    this.customAuditoria[0].loading = true;
    let nuevadata = [];
    this.datatableAuditoriaNaveViaje.forEach((row) => {
      const {
        operacion,
        direccion_ip,
        nombre_maquina,
        nombre_aplicacion,
        usuario_sql,
        audi_fecmod,
        codigo_viaje,
        estado_viaje,
        numero_viaje,
        codigo_nave,
        fecha_cut_off,
        codigo_puerto,
        trafico,
        codigo_trafico,
        regimen,
        codigo_regimen,
        via,
        codigo_via,
        codigo_transportista,
        codigo_agente_portuario,
        codigo_agente_vobo1,
        codigo_terminal_portuario,
        codigo_agente_vobo2,
        fecha_eta_etd,
        fecha_descarga,
        fecha_llegada_zarpe,
        fecha_recogo_docs,
        fecha_termino_embarque,
        fecha_cierre,
        numero_manifiesto,
        manifiesto_desconsolidado,
        usuario_emite_statment,
        fecha_emite_statment,
        emitio_statment,
        usuario_prefactura,
        fecha_prefactura,
        usuario_cierra_nave,
        fecha_cierra_nave,
        usuario_crea,
        fecha_crea,
        usuario_modifica,
        fecha_modifica,
        caba_ano,
        caba_mes,
        tipo_tabreg,
        tipo_codreg,
        caba_nrovoucher,
      } = row;
      const newItem = {
        OPERACION: operacion,
        'DIRECCION IP': direccion_ip,
        'NOMBRE MÁQUINA': nombre_maquina,
        'USUARIO SQL': usuario_sql,
        'NOMBRE APLICACIÓN': nombre_aplicacion,
        'FECHA MODIFICACIÓN':
          audi_fecmod != null
            ? this.util.formatearfecha(audi_fecmod, 'dd/mm/yyyy')
            : null,
        'CÓDIGO VIAJE': codigo_viaje,
        'ESTADO VIAJE': estado_viaje,
        'NÚMERO VIAJE': numero_viaje,
        'CÓDIGO NAVE': codigo_nave,
        'FECHA CUT OFF':
          fecha_cut_off != null
            ? this.util.formatearfecha(fecha_cut_off, 'dd/mm/yyyy')
            : null,
        'CÓDIGO PUERTO': codigo_puerto,
        TRÁFICO: trafico,
        'CÓDIGO TRÁFICO': codigo_trafico,
        RÉGIMEN: regimen,
        'CÓDIGO RÉGIMEN': codigo_regimen,
        VÍA: via,
        'CÓDIGO VÍA': codigo_via,
        'CÓDIGO TRANSPORTISTA': codigo_transportista,
        'CÓDIGO AGENTE PORTUARIO': codigo_agente_portuario,
        'CÓDIGO AGENTE VOBO1': codigo_agente_vobo1,
        'CÓDIGO TERMINAL PORTUARIO': codigo_terminal_portuario,
        'CÓDIGO AGENTE VOBO2': codigo_agente_vobo2,
        'FECHA ETA ETD':
          fecha_eta_etd != null
            ? this.util.formatearfecha(fecha_eta_etd, 'dd/mm/yyyy')
            : null,
        'FECHA DESCARGA':
          fecha_descarga != null
            ? this.util.formatearfecha(fecha_descarga, 'dd/mm/yyyy')
            : null,
        'FECHA LLEGADA ZARPE':
          fecha_llegada_zarpe != null
            ? this.util.formatearfecha(fecha_llegada_zarpe, 'dd/mm/yyyy')
            : null,
        'FECHA RECOGO DOCS':
          fecha_recogo_docs != null
            ? this.util.formatearfecha(fecha_recogo_docs, 'dd/mm/yyyy')
            : null,
        'FECHA TÉRMINO EMBARQUE':
          fecha_termino_embarque != null
            ? this.util.formatearfecha(fecha_termino_embarque, 'dd/mm/yyyy')
            : null,
        'FECHA CIERRE':
          fecha_cierre != null
            ? this.util.formatearfecha(fecha_cierre, 'dd/mm/yyyy')
            : null,
        'NÚMERO MANIFIESTO': numero_manifiesto,
        'MANIFIESTO DESCONSOLIDADO': manifiesto_desconsolidado,
        'USUARIO EMITE STATEMENT': usuario_emite_statment,
        'FECHA EMITE STATEMENT':
          fecha_emite_statment != null
            ? this.util.formatearfecha(fecha_emite_statment, 'dd/mm/yyyy')
            : null,
        'EMITIÓ STATEMENT': emitio_statment,
        'USUARIO PREFACTURA': usuario_prefactura,
        'FECHA PREFACTURA':
          fecha_prefactura != null
            ? this.util.formatearfecha(fecha_prefactura, 'dd/mm/yyyy')
            : null,
        'USUARIO CIERRA NAVE': usuario_cierra_nave,
        'FECHA CIERRA NAVE':
          fecha_cierra_nave != null
            ? this.util.formatearfecha(fecha_cierra_nave, 'dd/mm/yyyy')
            : null,
        'USUARIO CREA': usuario_crea,
        'FECHA CREA':
          fecha_crea != null
            ? this.util.formatearfecha(fecha_crea, 'dd/mm/yyyy')
            : null,
        'USUARIO MODIFICA': usuario_modifica,
        'FECHA MODIFICA':
          fecha_modifica != null
            ? this.util.formatearfecha(fecha_modifica, 'dd/mm/yyyy')
            : null,
        CABA_ANO: caba_ano,
        CABA_MES: caba_mes,
        TIPO_TABREG: tipo_tabreg,
        TIPO_CODREG: tipo_codreg,
        CABA_NROVOUCHER: caba_nrovoucher,
      };
      nuevadata.push(newItem);
    });
    const data = [{ data: nuevadata, cabeceras: [] }];
    this.util.ExportarExcel(data, 'AUDITORIA NAVE VIAJE.xlsx');
    this.customAuditoria[1].loading = false;
  }

  exportarAuditoriaDetNV() {
    if (this.datatableAuditoriaNaveViaje.length == 0) {
      this.util.showMessageError('No hay campos para exportar');
      return;
    }
    this.customDetAuditoria[0].loading = true;
    let nuevadata = [];
    this.datatableAuditoriaDetNaveViaje.forEach((row) => {
      const {
        operacion,
        direccion_ip,
        nombre_maquina,
        nombre_aplicacion,
        usuario_sql,
        usuario_aplicacion,
        fecha_modificacion,
        cod_nave_viaje,
        item,
        cod_puerto,
        fec_eta_etd,
        usuario_crea,
        fec_crea,
        usuario_modifica,
        fec_modifica,
      } = row;
      const newItem = {
        OPERACION: operacion,
        'DIRECCION IP': direccion_ip,
        'NOMBRE MÁQUINA': nombre_maquina,
        'NOMBRE APLICACIÓN': nombre_aplicacion,
        'USUARIO SQL': usuario_sql,
        'USUARIO APLICACIÓN': usuario_aplicacion,
        'FECHA MODIFICACIÓN':
          fecha_modificacion != null
            ? this.util.formatearfecha(fecha_modificacion, 'dd/mm/yyyy')
            : null,
        'COD NAVE VIAJE': cod_nave_viaje,
        ITEM: item,
        'COD PUERTO': cod_puerto,
        'FECHA ETA ETD':
          fec_eta_etd != null
            ? this.util.formatearfecha(fec_eta_etd, 'dd/mm/yyyy')
            : null,
        'USUARIO CREA': usuario_crea,
        'FEC CREA':
          fec_crea != null
            ? this.util.formatearfecha(fec_crea, 'dd/mm/yyyy')
            : null,
        'USUARIO MODIFICA': usuario_modifica,
        'FEC MODIFICA':
          fec_modifica != null
            ? this.util.formatearfecha(fec_modifica, 'dd/mm/yyyy')
            : null,
      };
      nuevadata.push(newItem);
    });
    const data = [{ data: nuevadata, cabeceras: [] }];
    this.util.ExportarExcel(data, 'AUDITORIA DETALLE NAVE VIAJE.xlsx');
    this.customDetAuditoria[1].loading = false;
  }

  marcarCamposComoTocados() {
    Object.values(this.group_edicion.controls).forEach((control) => {
      control.markAsTouched();
    });
  }

  archivosFuncion(tipo: string) {
    switch (tipo) {
      case 'D':
        break;
      case 'VoBo':
        break;
    }
  }

  emailFuncion(tipo: string) {
    switch (tipo) {
      case 'A':
        break;
      case 'CR':
        break;
      case 'DA':
        break;
      case 'L':
        break;
      case 'LCL':
        break;
      case 'FCL':
        break;
    }
  }

  validateFeederFinal(event: any, tipo: string) {
    let cod_puerto;
    if (tipo == 'EVE') {
      cod_puerto = event.value;
    } else {
      cod_puerto = event;
    }

    if (this.origen === 'orden_venta') {
      const values = this.group_edicion.value;
      this.group_edicion.get('viajefeeder').setValue(false);

      if (cod_puerto) {
        if (values.Regimen === '001') {
          if (cod_puerto === this.dataordenventa.puer_coddestino.toString()) {
            this.messageService.add({
              severity: 'info',
              summary: 'Puerto destino',
              detail: 'La nave se va ha marcar como final.',
              life: 3000,
            });
          } else {
            this.messageService.add({
              severity: 'info',
              summary: 'Puerto destino',
              detail: 'La nave se debe marcar como nave feeder.',
              life: 3000,
            });
            this.group_edicion.get('viajefeeder').setValue(true);
          }
        } else {
          // if (cod_puerto !== this.dataordenventa.puer_codorigen.toString()) {
          if (cod_puerto === this.dataordenventa.puer_codorigen.toString()) {
            this.messageService.add({
              severity: 'info',
              summary: 'Puerto destino',
              detail: 'La nave se va ha marcar como final.',
              life: 3000,
            });
          } else {
            this.messageService.add({
              severity: 'info',
              summary: 'Puerto destino',
              detail: 'La nave se debe marcar como nave feeder.',
              life: 3000,
            });
            this.group_edicion.get('viajefeeder').setValue(true);
          }
        }
      }
    }
  }

  formatDateToSQL(date: string): string {
    if (date === null) return null;
    const dateObj = new Date(date);
    const year = dateObj.getFullYear();
    const month = String(dateObj.getMonth() + 1).padStart(2, '0'); // enero = 0
    const day = String(dateObj.getDate()).padStart(2, '0');

    const hours = String(dateObj.getHours()).padStart(2, '0');
    const minutes = String(dateObj.getMinutes()).padStart(2, '0');
    const seconds = String(dateObj.getSeconds()).padStart(2, '0');

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }

  resetHora = false;
  onFechaLlegadaSelect(nuevaFecha: Date) {
    const control = this.group_edicion.get('Llegada');
    const fec_orig = this.group_edicion.get('Llegada_orig');
    if (fec_orig == null && this.resetHora == false) {
      nuevaFecha.setHours(0, 0, 0, 0);
      control.setValue(nuevaFecha);
      this.resetHora = true;
    } else { }
  }

}
